export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/amazon.ceabc3d.svg";